<template>
	<div class="view message-view">
		<HeaderBar>
			<img class="delete-img"
				 @click="onClearClick"
				 src="../../assets/images/delete.png" />
		</HeaderBar>
		<ul class="msg-wrap">
			<li class="msg-item"
				v-for="item in msgList"
				:key="item.id"
				:class="{'is-expanded': item.id === expanded, 'is-read': item.is_read}"
				@click="onItemClick(item.id)">
				<div class="title">{{ item.title }}</div>
				<div class="text--sub">{{ item.content }}</div>
				<div class="text-date">{{item.date}}</div>
			</li>
		</ul>
		<div class="no-msg text--sub"
			 v-if="msgList.length === 0">暂无消息</div>
		<div class="load-more"
			 @click="onLoadMoreClick"
			 v-if="hasMore">加载更多...</div>
	</div>
</template>
<script>
import { Dialog } from 'vant';
import HeaderBar from '../../components/HeaderBar';
import apiUtil from '../../utils/apiUtil';
import apiConst from '../../consts/apiConst';
export default {
	name: 'message',
	components: {
		HeaderBar
	},
	data() {
		return {
			msgList: [

			],
			expanded: 0,
			page: 1,
			hasMore: true
		};
	},
	created() {
		this.init();
	},
	methods: {
		async init(page = 1) {
			const res = await apiUtil.post(apiConst.getMessage, { page, pagesize: 10 });
			if (res.success) {
				this.msgList = this.msgList.concat(res.list);
				if (res.list.length > 0) {
					this.page = page;
					if (res.list.length < 10) {
						this.hasMore = false;
					}
				} else {
					this.hasMore = false;
				}
			}
		},
		onClearClick() {
			Dialog.confirm({
				title: '提示',
				message: '确定要清空消息吗？'
			})
				.then(async () => {
					const res = await apiUtil.post(apiConst.clearMessage);
					if (res.success) {
						this.msgList = [];
					}
				})
				.catch(() => { });
		},
		onItemClick(id) {
			if (this.expanded === id) {
				this.expanded = 0
			} else {
				this.expanded = id
			}

		},
		onLoadMoreClick() {
			this.init(this.page + 1)
		}
	}
};
</script>
<style lang="stylus" scoped>
.message-view {
	.delete-img {
		width: 38px;
		height: 40px;
	}

	.msg-item {
		height: 195px;
		padding: 30px 44px;
		border-bottom: 1PX solid #f1f1f1;

		.title {
			font-size: 32px;
			color: #333;
			font-weight: bold;
			margin-bottom: 25px;
		}
		.text-date{
			font-size: 28px;
			color: #262626;
			margin-top:10px;
			margin-bottom: 25px;
			padding-bottom:25px;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 1;
			overflow: hidden;
		}
		.text--sub {
			font-size: 30px;
			line-height:45px;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 1;
			color:#262626;
			overflow: hidden;
		}

		&.is-expanded {
			height: auto;

			.text--sub {
				display: block;
			}
		}

		&.is-read {
			.title {
				color: #C6C6C6;
			}

			.text--sub {
				color: #B9B9B9;
			}
			.text-date{
				color: #B9B9B9;
			}
		}
	}

	.no-msg {
		text-align: center;
		padding: 20px;
	}

	.load-more {
		text-align: center;
		padding: 20px;
		font-size: 32px;
		color: #666;
	}
}
</style>
